import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
  standalone: false
})
export class LogoutFormComponent implements OnInit {


  constructor(private router: Router, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.logout();
  }

  logout() {
    this.authService.AccessDetails$.next({} as any);
    this.authService.AccessDetails$.complete();
    this.authService.Authorization$.next('');
    this.authService.Authorization$.complete();
    this.authService.IsAdminUser$.next(false);
    this.authService.IsTenantUser$.next(false);
    this.authService.IsMerchantUser$.next(false);
    this.authService.hostName$.next('');
    this.authService.loginHostName$.next('');
    this.authService.UserName$.next('');
    this.authService.Session$.next('');
    this.authService.stage$.next('');

    localStorage.removeItem('Authorization');
    localStorage.removeItem('IsAdminUser');
    localStorage.removeItem('IsTenantUser');
    localStorage.removeItem('IsMerchantUser');
    localStorage.removeItem('hostName');
    localStorage.removeItem('UserName');
    localStorage.removeItem('Session');
    localStorage.removeItem('loginHostName');
    localStorage.removeItem('accessKey');
    localStorage.removeItem('loginType');
    localStorage.removeItem('stage');
    this.router.navigate(['/login']);
  }

}
